import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  AbstractControlOptions,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  StripeCardElementOptions,
  StripeElementsOptions,
  TokenResult,
} from '@stripe/stripe-js';
import { StripeCardNumberComponent, StripeService } from 'ngx-stripe';
import { FormService } from 'src/app/shared/services/form.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { NotifierService } from 'src/app/shared/services/notifier.service';

import {
  formNoWhitespaceValidator,
  patterns,
} from 'src/app/validators/pattern_validation';

@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.scss'],
})
export class PaymentFormComponent {
  @Output() buttonClick = new EventEmitter<any>();
  cardNumberValid = false;
  cardExpiryValid = false;
  cardCvcValid = false;
  async onButtonClick() {
    // Emit event when button is clicked
    const token = await this.createToken();
    this.buttonClick.emit(token);
  }

  form!: FormGroup;
  @ViewChild(StripeCardNumberComponent) card!: StripeCardNumberComponent;

  public cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#red31325F',
        fontWeight: '300',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '14px',
        '::placeholder': {
          color: '#CFD7E0',
        },
        '::selection': {
          backgroundColor: '#DA3C3D',
          color: '#F6D8DA',
        },
      },
    },
  };

  public elementsOptions: StripeElementsOptions = {
    locale: 'en',
  };

  constructor(
    private stripeService: StripeService,
    private formBuilder: FormBuilder,
    private formService: FormService,
    private _LoaderService: LoaderService,
    private _NotifierService: NotifierService
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group(
      {
        name_on_card: [
          '',
          [
            Validators.required,
            Validators.pattern(patterns.NAME_ON_CARD.regex),
          ],
        ],

        address1: [
          '',
          [Validators.required],
        ],
        address2: [
          '',
          [Validators.required],
        ],
        postcode: [
          '',
          [Validators.required, Validators.pattern(patterns.POSTCODE.regex)],
        ],
        city: [
          '',
          [Validators.required, Validators.pattern(patterns.CITY.regex)],
        ],
      },
      { validators: [formNoWhitespaceValidator] } as AbstractControlOptions
    );
  }
  getErrorMessage(controlName: string): string {
    return this.formService.getErrorMessage(controlName, this.form);
  }

  onChange(ev: any, elementType: string) {
    let displayError: HTMLElement | null;
    switch (elementType) {
      case 'cardNumber':
        displayError = document.getElementById('card-number-errors');
        !ev?.empty && ev?.empty !== undefined
        ? (this.cardNumberValid = true)
        : (this.cardNumberValid = false);

        ev?.complete && ev?.complete !== undefined
          ? (this.cardNumberValid = true)
          : (this.cardNumberValid = false);
        break;
      case 'cardExpiry':
        displayError = document.getElementById('card-expiry-errors');
        !ev?.empty && ev?.empty !== undefined
        ? (this.cardExpiryValid = true)
        : (this.cardExpiryValid = false);

        ev?.complete && ev?.complete !== undefined
          ? (this.cardExpiryValid = true)
          : (this.cardExpiryValid = false);
        break;
      case 'cardCvc':
        displayError = document.getElementById('card-cvc-errors');
        !ev?.empty && ev?.empty !== undefined
        ? (this.cardCvcValid = true)
        : (this.cardCvcValid = false);

        ev?.complete && ev?.complete !== undefined
          ? (this.cardCvcValid = true)
          : (this.cardCvcValid = false);
        break;
      default:
        displayError = null;
        break;
    }
    if (ev?.empty && displayError) {
      displayError.textContent =
        'Enter ' +
        ev.elementType.replace(/([a-z])([A-Z])/g, '$1 $2').toLocaleLowerCase();
    } else if (!ev?.complete && displayError) {
      displayError.textContent = ev.error?.message;
    } else {
      displayError!.innerHTML = '';
    }
  }

  createToken() {
    this._LoaderService.setState(true);
    const name = this.form.get('name_on_card')?.value;

    return new Promise((resolve, reject) => {
      this.stripeService
        .createToken(this.card.element, { name })
        .subscribe((result: TokenResult) => {
          if (result.token) {
            this._LoaderService.setState(false);
            resolve(result.token); // Resolve with the token ID
          } else if (result.error) {
            this._LoaderService.setState(false);
            this._NotifierService.showError(result.error.message);
            console.log(result.error.message);
            reject(result.error.message); // Reject with the error message
          }
        });
    });
  }
}
